<template>
  <div class="buttons">
    <change-password />
    <logout />
  </div>
</template>

<script>
import ChangePassword from '@/components/common/ChangePassword.vue';
import Logout from '@/components/common/Logout.vue';

export default {
  components: {
    ChangePassword,
    Logout,
  },
};
</script>

<style lang="scss" scoped>
.buttons {
  display: flex;
  flex-direction: column;
  padding-top: 0;
}
</style>
